import { type IPurchaseItem } from "@/interfaces/api/purchase-item.interface"
import { PurchaseItemRepository } from "@/repositories/purchase-item-repository"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { PurchaseItem } from "@/models/purchase-item.model"
import { usePurchaseItemStore } from "@/store/purchase-items.store"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export class PurchaseItemController extends GenericModelController<
  PurchaseItem,
  IPurchaseItem,
  PurchaseItemRepository
> {
  constructor() {
    const purchaseItemStore = usePurchaseItemStore()
    const { purchaseItems } = storeToRefs(purchaseItemStore)

    const storeFunctionsConfig = {
      collection: purchaseItems
    }

    super(PurchaseItem, storeFunctionsConfig, new PurchaseItemRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      PurchaseItem,
      purchaseItems
    )
  }
}
